import { useMemo } from 'react'
import ModalProviders from '../common/providers/ModalProviders'
import CommonDrawerContextProviders, { useLinkedCommonDrawerState } from '../common/context/CommonDrawerContexts'
import { globalDispatch } from '../common/utils/Sparky'
import { LoadingPlaceholder } from '@sparky/framework'
import Header from './Header'
import Subscription from '../subscription'
import MessageProvider from '../common/providers/MessageProvider'
import { VIEW_MANAGE_SUBSCRIPTION } from '../common/constants/GlobalConstants'
import type { VFC } from 'react'
import type { CommonModuleProps } from '../common/types'

const Subscriptions: VFC<CommonModuleProps> = ({ auth, commonModule }) => {
  const {
    treeReducer,
    viewReducer,
    instanceReducer,
    appReducer,
    licenseReducer,
    iamReducer,
    deviceReducer,
    subscriptionReducer,
    dispatch,
    initializing,
  } = useLinkedCommonDrawerState()

  const props = useMemo(() => {
    return {
      ...appReducer,
      ...treeReducer,
      ...viewReducer,
      ...instanceReducer,
      dispatch,
      iamReducer,
      licenseReducer,
      deviceReducer,
      globalDispatch,
      commonModule: {
        ...commonModule,
        path: VIEW_MANAGE_SUBSCRIPTION,
        visible: true,
      },
      subscriptionReducer,
      inCommonServicesPage: true,
      auth
    }
  }, [appReducer, auth, commonModule, deviceReducer, dispatch, iamReducer, instanceReducer, licenseReducer, subscriptionReducer, treeReducer, viewReducer])

  const header = useMemo(() => <Header title='Subscriptions' />, [])

  if (initializing) {
    return <LoadingPlaceholder />
  }
  return (
    <div className='cm-w-full cm-h-full cm-flex cm-flex-col'>
      <CommonDrawerContextProviders>
        <ModalProviders>
          {header}
          <div className='cm-relative cm-flex-1 cm-h-full cm-overflow-y-auto cm-bg-white dark:cm-bg-gray-1050'>
            <MessageProvider>
              <Subscription {...props} />
            </MessageProvider>
          </div>
        </ModalProviders>
      </CommonDrawerContextProviders>
    </div>
  )
}
export default Subscriptions
